import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, mergeProps as _mergeProps, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/gal-logo/assets001.png'
import _imports_1 from '@/assets/klleon-logo/assets001.svg'


const _withScopeId = n => (_pushScopeId("data-v-5478cd85"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex items-center justify-center h-screen flex-col" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex mb-12 gap-12" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "w-52 h-auto"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    class: "w-52 h-auto"
  })
], -1))
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 로그인 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UserOutlined = _resolveComponent("UserOutlined")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_LockOutlined = _resolveComponent("LockOutlined")!
  const _component_a_input_password = _resolveComponent("a-input-password")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_a_form, { model: _ctx.formState }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form_item, _mergeProps(_ctx.layout, {
          label: "아이디",
          name: "username",
          rules: [{ required: true, message: '아이디를 입력해주세요.' }]
        }), {
          default: _withCtx(() => [
            _createVNode(_component_a_input, {
              value: _ctx.formState.username,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formState.username) = $event)),
              type: "email"
            }, {
              prefix: _withCtx(() => [
                _createVNode(_component_UserOutlined)
              ]),
              _: 1
            }, 8, ["value"])
          ]),
          _: 1
        }, 16, ["rules"]),
        _createVNode(_component_a_form_item, _mergeProps(_ctx.layout, {
          label: "비밀번호",
          name: "password",
          rules: [{ required: true, message: '비밀번호를 입력해주세요.' }]
        }), {
          default: _withCtx(() => [
            _createVNode(_component_a_input_password, {
              value: _ctx.formState.password,
              "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formState.password) = $event))
            }, {
              prefix: _withCtx(() => [
                _createVNode(_component_LockOutlined)
              ]),
              _: 1
            }, 8, ["value"])
          ]),
          _: 1
        }, 16, ["rules"]),
        _createVNode(_component_a_form_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_a_button, {
              type: "primary",
              "html-type": "submit",
              class: "w-full",
              style: {"background-color":"#40a9ff"},
              onClick: _withModifiers(_ctx.submit, ["prevent"])
            }, {
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model"])
  ]))
}